import React from 'react';
import NoSearchResultsIcon from 'assets/no_search_results_found.svg';

const DetailPanelEmptyState = ({
  title = 'No Results Found',
  content,
  actions
}: {
  title?: string;
  content: React.ReactNode;
  actions?: React.ReactNode;
}) => {
  return (
    <div
      className="application-detail-panel w-full bg-neutral-10 overflow-auto"
      style={{ minHeight: 'calc(100vh - 63px)' }}
    >
      <div className="bg-white m-4 shadow-sm-card rounded-lg flex flex-col items-center justify-center p-16">
        <img src={NoSearchResultsIcon} alt="No results found illustration" />
        <div className="flex flex-col items-center justify-center gap-2">
          <h2 className="text-sm font-semibold">{title}</h2>
          {content}
        </div>
        {actions}
      </div>
    </div>
  );
};

export default DetailPanelEmptyState;
